import { compress, decompress } from 'lz-string';

const tryParseJson = (value, fallback = null) => {
    if (value == null) {
        return fallback;
    }

    try {
        return JSON.parse(value);
    } catch (error) {
        return fallback;
    }
};

const decompressValue = (value) => {
    if (value == null) {
        return null;
    }

    try {
        const decompressed = decompress(value);
        return decompressed ?? value;
    } catch (error) {
        return value;
    }
};

export const compressedLocalStorage = {
    getItem(key) {
        return localStorage.getItem(key);
    },
    setItem(key, value) {
        localStorage.setItem(key, compress(value));
    },
    removeItem(key) {
        localStorage.removeItem(key);
    },
};

export const setCompressedJsonItem = (key, value) => {
    compressedLocalStorage.setItem(key, JSON.stringify(value));
};

export const getCompressedJsonItem = (key, fallback = null) => {
    const rawValue = compressedLocalStorage.getItem(key);
    if (rawValue == null) {
        return fallback;
    }

    const parsedCompressed = tryParseJson(decompressValue(rawValue), undefined);
    if (parsedCompressed !== undefined) {
        return parsedCompressed;
    }

    const parsedPlain = tryParseJson(rawValue, undefined);
    if (parsedPlain !== undefined) {
        return parsedPlain;
    }

    return fallback;
};
